import type { ReactNode } from 'react';

export const symbol_hand_package: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M620-821H340v312h280v-312Zm200 0H680v312h140v-312ZM571-449H310v270h228q22.66 0 43.7-7.5Q602.74-194 620-209l175-155q-14-12-29-19t-32-9q-17-2-32.5 2.5T672-374l-89 72q-8 7-17.62 10-9.61 3-20.38 3h-95q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h96l46-38q10-8 12.5-18t-.5-20q-3-10-11.5-17t-21.5-7Zm-321 0H140v310h110v-310Zm30 0v-371q0-24 18-42t42-18h480q24 0 42 18t18 42v311q0 24-18 42t-42 18H280ZM250-79H140q-24 0-42-18t-18-42v-310q0-24 18-42t42-18h431q81 0 154 29t126 89h1q12 14 11 31t-15 29L660-164q-25 22-57 33.5T538-119H306q-7 17-22.21 28.5Q268.59-79 250-79Z"
		/>
	</svg>
);
